
import React from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';

/**
 * LexSmart AI - Entry Point
 * Această secțiune pornește motorul React și injectează aplicația în index.html
 */
const container = document.getElementById('root');

if (container) {
  console.log("%c LexSmart: Root container găsit. Se montează aplicația... ", "color: #6366f1; font-weight: bold;");
  const root = createRoot(container);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
} else {
  console.error("CRITICAL ERROR: Elementul #root lipsește din index.html. Verificați integritatea fișierului.");
}
